import { render, staticRenderFns } from "./moralEducationData.vue?vue&type=template&id=eff43a00&scoped=true"
import script from "./moralEducationData.vue?vue&type=script&lang=js"
export * from "./moralEducationData.vue?vue&type=script&lang=js"
import style0 from "./moralEducationData.vue?vue&type=style&index=0&id=eff43a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff43a00",
  null
  
)

export default component.exports